import { MtLang } from './MtLang';

export const mtLangResolved = new MtLang().resolve();
